<template>
  <div class="privacy-page">
    <div class="header">
      <h1>隐私协议</h1>
    </div>

    <div class="container">
      <div class="content">
        <div class="update-info">
          <p>更新日期：2024 年 12 月 18 日</p>
          <p>生效日期：2024 年 12 月 18 日</p>
        </div>

        <div class="content-text">
            <p><b>尊敬的用户：</b></p>
            <p>
“恰恰好”APP（以下统称为“本应用”）是由为您提供为的饮食记录工具平台。如您的使用过程中遇到问题可以通过邮件与我们联系。<br>
所有本应用产品或服务均适用本政策。本政策介绍了我们在向您提供本应用产品或服务的过程中处理您个人信息的目的、方式、范围、保存期限和信息安全保护措施，以及您行使法律规定权利的方式和程序。请您结合我们的《用户使用协议》仔细阅读本政策，并在同意本政策约定内容的情况下使用本应用产品或服务。对所有重点内容，我们将采用“加粗”的书写方式进行提示。 以下是我们的特别提示，请您重点关注：<br>
（1）为了保障产品的正常运行，实现上传图片、拍摄照片以及其他功能，我们会收集你的部分必要信息；<br>
（2）在你进行上传资料、注册认证的服务时，基于法律要求或实现功能所必需，我们可能会收集手机号、图文、音视频文件的个人信息。你有权拒绝向我们提供这些信息，或者撤回你对这些信息的授权同意。请你了解，拒绝或撤回授权同意，将导致你无法使用相关的特定功能，但不影响你使用“本应用”的其他功能；<br>
（3）我们会将在境内运营过程中收集和产生的你的个人信息存储于中华人民共和国境内，不会将上述信息传输至境外。我们仅会在为提供“本应用”软件及相关服务之目的所必需的期间内保留你的个人信息；<br>
（4）我们不会向第三方共享、提供、转让或者从第三方获取你的个人信息，除非经过你的同意；<br>
（5）我们将努力采取合理的安全措施来保护你的个人信息。特别的，我们将采用行业内通行的方式及尽最大的商业努力来保护你个人敏感信息的安全。<br>
（6）本应用会根据您的基础信息和已记录的饮食，为您计算每餐热量；<br>
（7）你访问、更正、删除个人信息与撤回同意授权的方式，以及投诉举报的方式。<br>
如你未明示同意本隐私政策并开始使用，我们将不会收集您的个人信息，这将导致我们无法为您提供完整的产品和服务。如您点击“同意”并确认提交，即视为您同意本隐私政策,并同意我们将按照本政策来收集、使用、存储和共享您的相关信息。<br>
我们非常重视用户个人信息的保护，并且将以勤勉和审慎的义务对待这些信息。你在下载、安装、开启、浏览、注册、登录、使用（以下统称“使用”）“本应用”软件及相关服务时，我们将按照本《隐私政策》收集、保存、使用、披露及保护你的个人信息。我们希望通过本《隐私政策》向你介绍我们对你个人信息的处理方式，因此我们建议你认真完整地阅读本《隐私政策》的所有条款。<br>
本隐私政策旨在帮助你了解以下内容：<br>
一、我们如何收集和使用个人信息 <br>
二、我们对 Cookie 和同类技术的使用 <br>
三、我们如何存储个人信息 <br>
四、我们如何共享、转让、公开披露个人信息 <br>
五、我们如何保护个人信息的安全 <br>
六、你的权利 <br>
七、隐私政策的修订和通知
八、适用范围
九、其他
            </p>

            <p>
一、我们如何收集和使用个人信息<br>
在你使用“恰恰好”软件及服务的过程中，我们将根据合法、正当、必要的原则，收集信息。我们收集或请你提供的信息将用于：<br>
1.保障产品的基础正常运行；<br>
2.实现各项功能和服务；<br>
3.优化、改善产品和服务；<br>
4.保障产品、服务以及用户使用安全；<br>
5.遵循法律法规与国家标准的规定。<br>
（一）我们直接收集与使用的个人信息，我们会按照如下方式收集你在使用服务时主动提供的，以及通过自动化手段收集你在使用功能或接受服务过程中产生的信息。<br>
1.保障“本应用”和服务的正常运行<br>
（1）当你使用“本应用”及相关服务时，为识别您的设备ID并预防恶意程序及反作弊、提高服务安全性、保障软件与服务的正常运行、保障运营质量及效率，我们会收集你的硬件型号、硬件屏幕尺寸、操作系统版本号、国际移动设备识别码（IMEI）、IP地址、软件版本号、网络接入方式及类型、操作日志、安装的应用信息或运行中的进程信息。当“本应用”置于后台时，为保障软件与服务的正常运行和第三方SDK的正常运作，我们会收集设备信息（AndroidID）。请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。<br>
（2）为保证第三方SDK的正常运作，我们会收集您运行中的进程信息，以判断主进程并初始化第三方SDK。<br>
（3）在您分享接受被分享的信息、参加活动、复制或关注信息的情形下，我们需要访问您的剪切板(剪贴板)内容，读取包含口令、分享码、链接，以为您实现跳转、分享、活动联动功能或服务，提升您的产品使用体验。<br>
2.注册、认证、登录“本应用”和相关服务<br>
（1）当你注册、登录“本应用”及相关服务时，你可以通过手机号创建账号，我们将通过发送短信验证码来验证你的身份是否有效，并且你可完善相关的网络身份识别信息（头像、昵称、性别、地区），收集这些信息是为了帮助你完成注册。你还可根据自身需求选择填写性别、生日、身高、体重。<br>
（2）用户在同意隐私协议后，注册、登录“本应用”时，为获取OAID（移动安全联盟广告标识符），我们将会收集设备制造商、设备型号、设备品牌、设备网络运营商名称、App包名及签名信息，或在对应应用商店的APPID；<br>
（3）你也可以使用第三方账号（微信）登录进入本应用，你此时将授权我们获取你在第三方平台注册的公开信息（微信：头像、昵称、性别），并在你同意本隐私政策后将你的第三方账号与你的本应用账户绑定，使你可以通过第三方账号直接登录并使用本产品和相关服务。<br>
3.为你提供图文发布的功能或服务。你主动发布图文、拍摄时，将收集图文信息，并展示你的昵称、头像、发布信息内容。我们会请求你授权相机、照片这些敏感权限。你如果拒绝授权提供，将无法使用此功能，但不影响你正常使用本应用的其他功能。<br>
4.帮助你购买、使用会员权益为了方便你购买、使用会员权益，并尽量降低可能存在的风险，本应用会记录会员权益的购买、与使用情况。这些信息是你使用会员权益功能所必需，拒绝提供会使你无法使用会员权益功能，但不影响你正常使用其他功能。<br>
5.开展营销活动当你选择参加我们举办的有关营销活动时，根据活动需要你可提供姓名、通信地址、联系方式、银行账号这些信息。这些信息中包含个人敏感信息，是你收到转账或者礼品所必要的，如果你拒绝提供这些信息，我们将可能无法向你转账或发放礼品。<br>
6.保障产品、服务及用户使用安全为帮助我们更好地了解“本应用”及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据。<br>
7.在你分享或接收被分享的信息、参加网页活动的情形下，我们需要在本地访问你的剪切板，读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动功能或服务。我们仅在本地识别出剪切板内容属于跳转、分享、活动联动指令时才会将其上传我们的服务器。除此之外，我们不会上传你剪切板的其他信息至我们的服务器。<br>

（二）我们可能从第三方获得的你的个人信息M<br>
1.当你主动使用第三方账号登录本应用时，我们会收集第三方平台注册的公开信息（微信：头像、昵称、性别）。<br>
2.用户因使用我们的产品或者服务而被我们收集的信息，例如其他用户上传上传图片包含中可能含有你的部分信息。<br>
（三）在获得你授权后，我们会向第三方提供个人信息。<br>
为向您提供完善的产品和服务，在某些情形下，我们需要与第三方公司、组织或个人共享您的个人信息。我们仅会出于合法、正当、最小必要且本指引所明确的目的与第三方分享您的个人信息，并且只会分享必要的个人信息。如果第三方改变或超越您原同意范围处理您的个人信息，我们会要求第三方再次征得您的同意。<br>
对我们与之共享个人信息的公司、组织和个人，我们会要求其严格遵守我们关于数据隐私保护的措施和要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行个人信息的处理，避免识别出个人身份，保障隐私安全。<br>
详细了解与第三方共享您个人信息的情况。<br>
（四）收集、使用个人信息目的变更的处理<br>
请你了解，随着我们业务的发展，可能会对“本应用”的功能和提供的服务有所调整变化。收集与使用的个人信息属于与原目的具有直接或合理关联。在与原目的无直接或合理关联的场景下，我们收集、使用你的个人信息，会再次进行告知，并征得你的同意。<br>
（五）依法豁免征得同意收集和使用的个人信息请你理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用你的个人信息无需征得你的授权同意<br>
（1）与国家安全、国防安全直接相关的；<br>
（2）与公共安全、公共卫生、重大公共利益直接相关的；<br>
（3）与犯罪侦查、起诉、审判和判决执行，直接相关的；<br>
（4）出于维护个人信息主体或其他个人的生命、财产，重大合法权益但又很难得到本人同意的；<br>
（5）所收集的你的个人信息是你自行向社会公众公开的；<br>
（6）从合法公开披露的信息中收集的你的个人信息的，如合法的新闻报道、政府信息公开的渠道；<br>
（7）根据你的要求签订或履行合同所必需的；<br>
（8）用于维护“本应用”软件及相关服务的安全稳定运行所必需的，如发现、处置“本应用”软件及相关服务的故障；<br>
（9）为合法的新闻报道所必需的；<br>
（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；<br>
（11）法律法规规定的其他情形。特别提示你注意，如信息无法单独或结合其他信息识别到你的个人身份，其不属于法律意义上你的个人信息；当你的信息可以单独或结合其他信息识别到你的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他你的个人信息结合使用时，则在结合使用期间，这些信息将作为你的个人信息按照本隐私政策处理与保护。<br>

二、对Cookie和同类技术的使用Cookie和同类技术是互联网中的通用常用技术。当你使用“本应用”软件及相关服务时，我们可能会使用相关技术向你的设备发送一个或多个Cookie或匿名标识符，以收集和存储你访问、使用本产品时的信息。我们使用Cookie和同类技术主要为了实现以下功能或服务：<br>
（一）保障产品与服务的安全、高效运转我们可能会设置认证与保障安全性的cookie或匿名标识符，使我们确认你是否安全登录服务，或者是否遇到盗用、欺诈等不法行为。这些技术还会帮助我们改进服务效率，提升登录和响应速度。<br>
（二）帮助你获得更轻松的访问体验使用此类技术可以帮助你省去重复你填写个人信息、输入搜索内容的步骤和流程。<br>
<br>
三、我们如何存储个人信息<br>
（一）信息存储的地点我们依照法律法规的规定，将在境内运营过程中收集和产生的你的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循国家相关规定，征求你的同意。<br>
（二）存储期限我们仅在为提供“本应用”及服务之目的所必需的期间内保留你的个人信息，例如，你上传的图文，我们会保留相关信息。超出必要期限后，我们将对你的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。<br>
<br>
四、我们如何共享、转让、公开披露个人信息<br>
（一）个人信息的共享、转让我们不会向第三方共享、转让你的个人信息，除非经过你本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。<br>
1.在下列情况下，我们可能会共享的个人信息<br>
（1）为实现特定功能而与业务合作伙伴共享当软件服务提供商、智能设备提供商或系统服务提供商与我们联合为你提供服务时，例如你需要使用地理位置功能时，为实现这一功能，我们可能会收集你的位置信息及相关设备信息（硬件型号、操作系统版本号、国际移动设备身份识别码（IMEI）、网络设备硬件地址（MAC））经过去标识化后并提供给前述提供商。你可以拒绝提供此类信息，但不影响你使用其他服务。<br>
2.对共享个人信息第三方主体的谨慎评估及责任约束<br>
（1）经你同意，我们只会与第三方共享实现目的所必要的信息。如果第三方因业务需要，确需超出前述授权范围使用个人信息的，该第三方将需再次征求你的同意。<br>
（2）对我们与之共享你个人信息的第三方，该些第三方会与我们签订保密协议。同时，我们会对其数据安全能力与环境进行评估并要求第三方以不低于本隐私政策所要求的保密和安全措施来处理该信息。<br>
3.收购、兼并、重组时个人信息的转让随着我们业务的持续发展，我们将有可能进行合并、收购、资产转让，你的个人信息有可能因此而被转移。在发生前述变更时，我们将按照法律法规及不低于本隐私政策所要求的安全标准继续保护或要求个人信息的继受方继续保护你的个人信息，否则我们将要求继受方重新征得你的授权同意。<br>
（二）个人信息的公开披露除对违规账号、欺诈行为进行处罚公告时，我们会披露相关账号的必要信息外，我们不会公开披露你的信息，除非遵循国家法律法规规定或者获得你的同意。我们公开披露你的个人信息会采用符合行业内标准的安全保护措施。<br>
（三）依法豁免征得同意共享、转让、公开披露的个人信息请你理解，在下列情形中，根据法律法规及国家标准，我们共享、转让、公开披露你的个人信息无需征得你的授权同意<br>
（1）与国家安全、国防安全直接相关的；<br>
（2）与公共安全、公共卫生、重大公共利益直接相关的；<br>
（3）与犯罪侦查、起诉、审判和判决执行等直接相关的；<br>
（4）出于维护你或其他个人的生命、财产等重大合法权益但又很难得到你的同意的；<br>
（5）你自行向社会公众公开的个人信息；<br>
（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。<br>
<br>
五、我们如何保护个人信息安全<br>
（一）我们非常重视你个人信息的安全，将努力采取合理的安全措施（包括技术方面和管理方面）来保护你的个人信息，防止你提供的个人信息被不当使用或未经授权的情况下被访问、公开披露、使用、修改、损坏、丢失或泄漏。<br>
（二）我们会使用不低于行业同行的加密技术、匿名化处理的合理可行的手段保护你的个人信息，并使用安全保护机制防止你的个人信息遭到恶意攻击。<br>
（三）我们会建立专门的安全部门、安全管理制度、数据安全流程保障你的个人信息安全。我们采取严格的数据使用和访问制度，确保只有授权人员才可访问你的个人 信息，并适时对数据和技术进行安全审计。<br>
（四）尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请你理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保你提供给我们的个人信息的安全性。你知悉并理解，你接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议你采取积极措施保护个人信息的安全，包括但不限于使用复杂密码、定期修改密码、不将自己的账号密码透露给他人。<br>
（五）我们会制定应急处理预案，并在发生用户信息安全事件时立即启动应急预案，努力阻止该等安全事件的影响和后果扩大。一旦发生用户信息安全事件（泄露、丢失）后，我们将按照法律法规的要求，及时向你告知：安全事件的基本情况和可能的影响、我们已经采取或将要采取的处置措施、你可自主防范和降低风险的建议、对你的补救措施。我们将及时将事件相关情况以推送通知、邮件、信函、短信的形式告知你，难以逐一告知时，我们会采取合理、有效的方式发布公告。同时，我们还将按照相关监管部门要求，上报用户信息安全事件的处置情况。<br>
（六）我们谨此特别提醒你，本隐私政策提供的个人信息保护措施仅适用于“本应用”软件及相关服务。一旦你离开“本应用”及相关服务，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护你在“本应用”软件及相关服务之外的软件、网站提交的任何个人信息，无论你登录、浏览或使用上述软件、网站是否基于“本应用”的链接或引导。<br>
六、你的权利<br>
我们非常重视你对个人信息的管理，并尽全力保护你对于你个人信息的访问、修改（更新或更正）、删除以及撤回授权同意的权利，以使你有能力保障你的隐私和安全。<br>
（一）访问、更正、删除你的个人信息<br>
你可以通过以下方式管理你的信息：<br>
当你完成“本应用”的账号注册、登录并进行合理和必要的身份验证后，你可以查阅、修改、删除你提交给“本应用”软件及相关服务的个人信息，在本应用“我的”—点击“头像”进入“个人信息”中查询、访问您的头像、昵称、性别、生日、身高并进行修改。<br>
（二）管理、撤回授权你的信息<br>
请你理解，特定的业务功能和服务将需要你的信息才能得以完成，当你撤回同意或授权后，公司无法继续为你提供撤回同意或授权所对应的功能和服务，也不再处理你相应的个人信息。但你撤回同意或授权的决定，不会影响公司此前基于你的授权而开展的个人信息处理。<br>
（三）举报、屏蔽信息你可以按照我们公示的制度进行投诉或举报。<br>
1. 如果你认为你的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索，你可以通过邮箱与我们联系。我们核查后会在15个工作日内反馈你的投诉与举报。<br>
（四）访问隐私政策你可以在注册页面，或者在登录个人账号“我-设置”查看本隐私政策的全部内容。<br>
（五）停止运营向你告知权利如我们停止运营，我们将及时停止收集你个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知你，并对所持有的你的个人信息进行删除或匿名化处理。<br>
七、隐私政策的修订和通知<br>
（一）为了给你提供更好的服务，“本应用”软件及相关服务将不时更新与变化，我们会适时对本隐私政策进行修订，该等修订构成本隐私政策的一部分并具有等同于本隐私政策的效力。但未经你明确同意，我们不会削减你依据当前生效的本隐私政策所应享受的权利<br>
（二）本隐私政策更新后，我们会在“本应用”应用程序客户端和官方网站发出更新版本，并在更新后的条款生效前以适当的方式提醒你更新的内容，以便你及时了解本隐私政策的最新版本。如你继续使用我们的服务，表示同意接受修订后的本政策的内容，但是如果更新的内容需要采集音视频、获取你手机号、地理位置的个人敏感信息，仍会再次以显著方式征求你的同意。<br>
（三）对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示的方式，说明隐私政策的具体变更内容）。本隐私政策所指的重大变更包括但不限于：<br>
1.我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息的类型、个人信息的使用方式；<br>
2.我们在所有权结构、组织架构方面发生重大变化。如业务调整、破产并购引起的所有变更；<br>
3.个人信息共享、转让或公开披露的主要对象发生变化；<br>
4.你参与个人信息处理方面的权利及其行使方式发生重大变化；<br>
5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时。<br>
八、适用范围<br>
本隐私权政策适用于由本开发者提供的所有服务，包括本应用客户端、网站。<br>
本隐私政策中所述的“本应用”及相关服务有可能会根据你所使用的手机型号、系统版本、软件应用程序版本的因素而有所不同。最终的产品和服务以你所使用的“本应用”软件及相关服务为准。如对本隐私政策内容有任何疑问、意见或建议，你可通过邮箱与我们联系。<br>
九、其他<br>
（一）本“隐私政策”中的标题仅为方便及阅读而设，并不影响本《隐私政策》中任何规定的含义或解释。<br>
（二）本“隐私政策”相关词语释义：<br>
    1.“恰恰好”软件及相关服务是指公司通过合法拥有并运营的、标注名称为“本应用”的客户端应用程序向你提供的产品与服务。<br>
    2.去标识化是指，通过对个人信息的技术处理，使其在不借助额外信息的情况下，无法识别个人信息主体的过程。<br>
    3.匿名化是指，通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后的信息不能被复原的过程。<br>
（三）本“隐私政策”的版权为我们所有，在法律允许的范围内，我们拥有解释和修改的权利。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy'
}
</script>

<style scoped>
.privacy-page {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 2rem;
}

.header {
  background-color: white;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  position: sticky;
  top: 0;
  z-index: 10;
}

.header h1 {
  margin: 0;
  font-size: 1.25rem;
  color: #333;
  text-align: center;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 1rem;
}

.content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  padding: 1.5rem;
  font-size: 0.95rem;
  line-height: 1.8;
  color: #333;
}

.update-info {
  color: #666;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #eee;
}

.update-info p {
  margin: 0.3rem 0;
}

/* 针对不同标题层级的样式 */
.content h1, .content h2, .content h3 {
  margin-top: 2rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.content h1 {
  font-size: 1.4rem;
  color: #222;
}

.content h2 {
  font-size: 1.2rem;
  color: #333;
}

.content h3 {
  font-size: 1.1rem;
  color: #444;
}

/* 针对列表的样式 */
.content ol, .content ul {
  padding-left: 1.5rem;
  margin: 1rem 0;
}

.content li {
  margin-bottom: 0.5rem;
}

/* 针对段落的样式 */
.content p {
  margin: 1rem 0;
  text-align: justify;
}

/* 适配移动端 */
@media screen and (max-width: 768px) {
  .container {
    padding: 0.5rem;
  }
  
  .content {
    padding: 1rem;
    font-size: 0.9rem;
  }
}
</style> 